module.exports = __webpack_public_path__ + "img/addfj.9d41c5f5.svg";